<template>
  <td>
    <template v-if="content === 'yes'">
      <v-icon color="success">done
      </v-icon>
    </template>
    <template v-else-if="content === 'no'">
      <v-icon color="error">clear
      </v-icon>
    </template>
    <template v-else>
      <!-- eslint-disable vue/no-v-html -->
      <span v-html="content"/>
      <!-- eslint-enable -->
    </template>
  </td>
</template>

<script>
export default {
    name: "ProductInfoTableDataCell",
    props: {
      content: {
        type: String,
        required: true
      }
    }
};
</script>
